"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewSimulationComponent = exports.SimulationDistributionChoices = void 0;
var App_1 = require("../../App");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var container_1 = require("./container");
var constants_1 = require("../../constants");
var charts_1 = require("./charts");
var stringUtils_1 = require("../lib/stringUtils");
var iterUtils_1 = require("../lib/iterUtils");
var utils_1 = require("../../utils");
var SimulationDistributionChoices = (function () {
    function SimulationDistributionChoices() {
    }
    SimulationDistributionChoices.asChoices = function () {
        return [
            {
                display_name: gettext("Erlang"),
                value: SimulationDistributionChoices.ERLANG.toString(),
            },
            {
                display_name: gettext("Triangular"),
                value: SimulationDistributionChoices.TRIANGULAR.toString(),
            }
        ];
    };
    SimulationDistributionChoices.ERLANG = 10;
    SimulationDistributionChoices.TRIANGULAR = 20;
    return SimulationDistributionChoices;
}());
exports.SimulationDistributionChoices = SimulationDistributionChoices;
var noDataPlaceholder = function (msg) {
    return React.createElement("div", { className: "pl-2" }, msg || gettext("No data"));
};
var OverviewSimulationComponent = (function (_super) {
    __extends(OverviewSimulationComponent, _super);
    function OverviewSimulationComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.drawPercentiles = function (percentileValues) { return function (svg, chart) {
            _this.props.percentiles.forEach(function (percentileOption) {
                var y = parseInt(percentileOption);
                var x = percentileValues[y];
                svg.select("g.nv-group").insert("line", ":first-child")
                    .attr("x1", chart.xAxis.range()[0])
                    .attr("y1", chart.y2Axis.scale()(y))
                    .attr("x2", chart.lines.xScale()(x))
                    .attr("y2", chart.y2Axis.scale()(y));
                svg.select("g.nv-group").insert("line", ":first-child")
                    .attr("x1", chart.lines.xScale()(x))
                    .attr("y1", chart.y2Axis.range()[0])
                    .attr("x2", chart.lines.xScale()(x))
                    .attr("y2", chart.y2Axis.scale()(y));
            });
        }; };
        return _this;
    }
    OverviewSimulationComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        if (props.data.length == 0)
            return noDataPlaceholder();
        var elements = props.data.map(function (matrixData) {
            return (React.createElement(container_1.Container, { fullWidth: true, key: "".concat(matrixData.matrix_title), containerTitle: matrixData.matrix_title },
                React.createElement("p", { className: "ml-2" },
                    gettext("No. of simulations"),
                    ": ",
                    matrixData.simulations),
                _this.props.eval_types.map(function (etype) {
                    var bars = matrixData.etypes[etype] && matrixData.etypes[etype].bars;
                    var curve = matrixData.etypes[etype] && matrixData.etypes[etype].curve;
                    var percentileValues = matrixData.etypes[etype] && matrixData.etypes[etype].percentiles;
                    var error = matrixData.etypes[etype] && matrixData.etypes[etype].error;
                    return (React.createElement(container_1.Container, { borderless: true, fullWidth: true, containerTitle: (0, stringUtils_1.capitalizeFirstLetter)(constants_1.EvaluationTypeChoices.display(parseInt(etype))) }, bars && curve ?
                        React.createElement("div", { className: "row" },
                            React.createElement("div", null,
                                React.createElement(charts_1.SimulationPlot, { key: etype, bars: bars, curve: curve, xLabel: matrixData.unit, processSvg: _this.drawPercentiles(percentileValues), showY2Axis: false })),
                            React.createElement("div", { className: "col-2" },
                                React.createElement(PercentileTable, { values: percentileValues, selected: props.percentiles, unit: matrixData.unit })))
                        : noDataPlaceholder(error)));
                })));
        });
        return (React.createElement("div", { className: "OverviewSimulation" },
            React.createElement(App_1.LoadingSpinner, { loading: props.isLoading, size: 10, className: "mt-5 pt-5" }, elements)));
    };
    OverviewSimulationComponent = __decorate([
        mobx_react_1.observer
    ], OverviewSimulationComponent);
    return OverviewSimulationComponent;
}(React.Component));
exports.OverviewSimulationComponent = OverviewSimulationComponent;
var PercentileTable = function (props) {
    return (React.createElement("table", { className: "table table-sm table-bordered table-hover table-responsive" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, gettext("Percentile")),
                React.createElement("th", null, gettext("Value")),
                React.createElement("th", null))),
        React.createElement("tbody", null, Object.keys(props.values)
            .filter(function (k) { return (0, iterUtils_1.contains)(props.selected, k); })
            .map(function (k) {
            return React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("b", null,
                        k,
                        "%")),
                React.createElement("td", null, (0, utils_1.toPrecision)(props.values[k])),
                React.createElement("td", null, props.unit));
        }))));
};
